<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "HardResetModal",
  components: {
    ModalWrapperChoice
  },
  data() {
    return {
      input: ""
    };
  },
  computed: {
    willHardReset() {
      return this.input === "Shrek is love, Shrek is life";
    },
    hasExtraNG() {
      return player.records.fullGameCompletions > 0;
    },
    hasSpeedrun() {
      return player.speedrun.isUnlocked;
    }
  },
  destroyed() {
    if (this.willHardReset) SecretAchievement(38).unlock();
  },
  methods: {
    hardReset() {
      if (this.willHardReset) GameStorage.hardReset();
      this.input = "";
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    :show-cancel="!willHardReset"
    :show-confirm="willHardReset"
    confirm-class="o-primary-btn--width-medium c-modal__confirm-btn c-modal-hard-reset-btn"
    @confirm="hardReset"
  >
    <template #header>
      ПОЛНЫЙ СБРОС
    </template>
    <div class="c-modal-message__text">
      Пожалуйста подтвердите ваше желание полностью сбросить данный слот сохранения.
      <span class="c-modal-hard-reset-danger">Удаление вашего слота не откроет ничего секретного.</span>
      Наберите "Shrek is love, Shrek is life" чтобы подтвердить.
      <div class="c-modal-hard-reset-danger">
        ЭТО СОТРЁТ ВАШЕ СОХРАНЕНИЕ.
        <span v-if="hasExtraNG">
          <br>
          Это также удалит всю косметику Глифов, которую вы открыли за прохождение игры!
        </span>
        <span v-if="hasSpeedrun">
          <br>
          Вы потеряете возможность сделать Спидран.
          Чтобы перезапустить ваш забег, используйте кнопку "Начать Спидран" вместо этого.
        </span>
      </div>
    </div>
    <input
      ref="input"
      v-model="input"
      type="text"
      class="c-modal-input c-modal-hard-reset__input"
      @keyup.esc="emitClose"
    >
    <div class="c-modal-hard-reset-info">
      <div
        v-if="willHardReset"
        class="c-modal-hard-reset-danger"
      >
        Фраза подтверждена - продолжение приведёт к необратимому удалению вашего сохранения!
      </div>
      <div v-else>
        Напишите необходимую фразу для продолжения.
      </div>
    </div>
    <template #confirm-text>
      ПОЛНЫЙ СБРОС
    </template>
  </ModalWrapperChoice>
</template>
